import { styled } from '@mui/material/styles';
import { colorPalette } from '../../colorPalette';
import Button from "@mui/material/Button";
export const StyledFeedbackButton = styled(Button)({
    fontSize: '14px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '16px',
    color: colorPalette.gray1000,
    borderColor: colorPalette.gray300,
    '&:hover': {
        backgroundColor: colorPalette.gray100,
        color: colorPalette.gray1000,
        borderColor: colorPalette.gray300,
    },
});
